import React, { useEffect, useState } from 'react'
import { IoIosArrowBack } from 'react-icons/io'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../../api/api'
import { useProfileStore } from '../../../store/useUserStore'
import { Swiper, SwiperSlide } from 'swiper/react'
import { toast } from 'react-toastify'
import { FiX } from 'react-icons/fi'
import { Pagination } from 'swiper/modules'
import { useTranslation } from 'react-i18next'


const AttendanceView = () => {
    const { attendanceId } = useParams()
    const navigate = useNavigate()
    const [attendanceData, setAttendanceData] = useState({
        branch_name: "",
        images: [],
        coaches: [],
        students: [],
        course_date: "",
        course_name: "",
        day: "",
        description: "",
        end_time: "",
        start_time: "",
        id: "",
    })
    const [replacementData, setReplacementData] = useState<any>(null)
    const { setLoading, attendanceData: reduxAttendanceData } = useProfileStore()
    const [previewImage, setPreviewImage] = useState<string | null>(null)
    const { t } = useTranslation()

    useEffect(() => {
        if (!reduxAttendanceData?.studentName) return navigate(`/attendance`)
        getAttendanceDetail()
        
        // Fetch replacement class data if eventId is present
        if (reduxAttendanceData?.eventId && reduxAttendanceData?.studentId) {
            getReplacementClassDetail()
        }
    }, [])

    function getAttendanceDetail() {
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/attendance/${attendanceId}`)
        .then( res => {
            console.log("attendance res", res)
            setAttendanceData(res.data.data)
        }).catch( err => {
            console.log("err", err)
        }).finally(()=>{
            setLoading(false)
        })
    }

    function getReplacementClassDetail() {
        if (!reduxAttendanceData?.eventId || !reduxAttendanceData?.studentId) return
        
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/event/class/${reduxAttendanceData.eventId}?student_id=${reduxAttendanceData.studentId}`)
        .then(res => {
            console.log("replacement class res", res)
            setReplacementData(res.data.data)
        }).catch(err => {
            console.log("replacement class err", err)
        }).finally(() => {
            setLoading(false)
        })
    }
    

    const navigateBack = () => {
        navigate(-1)
    }


    return (
        <div className="pb-20 px-3">
            <div className='mb-2 grid grid-cols-3'>
                <div className='col-span-1'><IoIosArrowBack size={28} color='#000' onClick={()=>navigateBack()}/></div>
                <div className='col-span-1 text-lg text-center font-medium'>{t("attendance.title")}</div>
                <div className='col-span-1'></div>
            </div>

            <div className='my-2 mt-4 grid grid-cols-2 text-base'>
                <div>
                    <span className='font-semibold'>{t("attendance.date")}:</span> {attendanceData.course_date}
                </div>
                <div>
                    <span className='font-semibold'>{t("attendance.time")}:</span> {attendanceData.start_time} - {attendanceData.end_time}
                </div>
            </div>
            
            <div className='my-2 grid grid-cols-2 text-base'>
                <div className='col-span-1'>
                    <span className='font-semibold'>{t("attendance.course_name")}:</span> {attendanceData.course_name}
                </div>
                <div className='col-span-1'>
                    <span className='font-semibold'>{t("attendance.branch_name")}:</span> {attendanceData.branch_name}
                </div>
            </div>

            {/* Replacement Class Details */}
            {replacementData && replacementData.type === 'replacement' && (
                <div className="mt-4 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-md">
                    <div className="font-semibold text-lg text-yellow-800 mb-3">
                        Replacement Class Details
                    </div>
                    
                    <div className="space-y-2">
                        <div className="grid grid-cols-2 gap-4 text-sm">
                            <div>
                                <span className="font-medium text-gray-700">Date:</span>
                                <span className="ml-2">{replacementData.replacement_date}</span>
                            </div>
                            <div>
                                <span className="font-medium text-gray-700">Day:</span>
                                <span className="ml-2">{replacementData.replacement_weekday?.label}</span>
                            </div>
                        </div>
                        
                        <div className="grid grid-cols-2 gap-4 text-sm">
                            <div>
                                <span className="font-medium text-gray-700">Time:</span>
                                <span className="ml-2">
                                    {replacementData.replacement_start_time} - {replacementData.replacement_end_time}
                                </span>
                            </div>
                            <div>
                                <span className="font-medium text-gray-700">Classroom:</span>
                                <span className="ml-2">{replacementData.replacement_classroom}</span>
                            </div>
                        </div>
                        
                        <div className="text-sm">
                            <span className="font-medium text-gray-700">Course:</span>
                            <span className="ml-2">{replacementData.replacement_course}</span>
                        </div>
                        
                        {replacementData.attendance && (
                            <div className="mt-3 pt-3 border-t border-yellow-200">
                                <div className="font-medium text-gray-700 mb-2">Attendance Status:</div>
                                <div className="bg-white p-3 rounded border">
                                    <div className="flex items-center justify-between">
                                        <span className="text-sm">{reduxAttendanceData?.studentName}</span>
                                        <div className="flex items-center">
                                            <label className="inline-flex cursor-pointer">
                                                <input 
                                                    type="checkbox" 
                                                    checked={!!replacementData.attendance?.attended} 
                                                    className="form-checkbox" 
                                                    readOnly
                                                />
                                            </label>
                                            <span className="ml-2 text-sm text-gray-600">
                                                {replacementData.attendance?.attended ? 'Attended' : 'Not Attended'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            
            <div className="mt-4 relative">
                <Swiper
                    pagination={{
                        dynamicBullets: true,
                    }}
                    modules={[Pagination]}>
                    {attendanceData.images.map((img: string, index: number) => (
                    <SwiperSlide key={index}>
                        <div className="grid place-items-center h-72 bg-white">
                            <img src={img} alt={`Slide ${index}`} className="object-contain max-h-full max-w-full" onClick={() => setPreviewImage(img)}/>
                        </div>
                    </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className='mt-4'>
                <div className='font-semibold text-base'>{t("attendance.today_focus")}:</div>
                <textarea rows={5} className='w-full bg-slate-200 rounded px-2 py-1 mt-2' value={attendanceData.description} disabled/>
            </div>

            
            <div className='mt-4'>
                <div className='font-semibold text-base'>{t("attendance.coaches")}</div>
                <div className="table-responsive">
                    <table className="">
                        <thead>
                            <tr>
                                <th>{t("attendance.name")}</th>
                                <th className='text-center'>{t("attendance.attended")}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {attendanceData.coaches && attendanceData.coaches.map((item:any, index:number) => {
                            return (
                                <tr key={index}>
                                    <td style={{width: "65%"}}>
                                        <div>{item.name}</div>
                                    </td>
                                    <td className="text-center">
                                        <div>
                                            <label className="inline-flex cursor-pointer">
                                                <input type="checkbox" checked={!!item.attend} className="form-checkbox" readOnly/>
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='mt-4'>
                <div className='font-semibold text-base'>{t("attendance.student")}</div>
                <div className="table-responsive">
                    <table className="">
                        <thead>
                            <tr>
                                <th>{t("attendance.name")}</th>
                                <th className='text-center'>{t("attendance.attended")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{width: "65%"}}>
                                    <div>{reduxAttendanceData?.studentName}</div>
                                </td>
                                <td className='text-center'>
                                    <div>
                                        <label className="inline-flex cursor-pointer">
                                            <input 
                                                type="checkbox" 
                                                checked={(() => {
                                                    const student = attendanceData.students?.find((s: any) => s.name === reduxAttendanceData?.studentName);
                                                    return student ? !!(student as any).attend : false;
                                                })()} 
                                                className="form-checkbox" 
                                                readOnly
                                            />
                                        </label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {previewImage && (
            <div className="fixed inset-0 bg-black bg-opacity-100 flex items-center justify-center z-[1100]" onClick={() => setPreviewImage(null)} >
                <div className="relative max-w-full max-h-full p-4" onClick={(e) => e.stopPropagation()} >

                    {/* Close button */}
                    <button onClick={() => setPreviewImage(null)} className="absolute top-2 left-2 bg-white text-black rounded-full p-1.5 shadow-md hover:bg-gray-100" aria-label="Close" >
                        <FiX size={18} />
                    </button>

                    <img src={previewImage} alt="Preview" className="max-h-[90vh] max-w-[90vw] object-contain rounded-md" />

                    <button
                        onClick={async () => {
                            try {
                                const response = await fetch(previewImage, { mode: 'cors' });
                                const blob = await response.blob();
                                const blobUrl = window.URL.createObjectURL(blob);

                                const link = document.createElement('a');
                                link.href = blobUrl;
                                link.download = 'attendance-image.jpg';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);

                                window.URL.revokeObjectURL(blobUrl);
                            } catch (err) {
                                toast.error("Download image failed");
                            }
                    }}
                    className="absolute -bottom-10 right-4 bg-theme text-white px-3 py-1.5 text-sm rounded-full shadow-lg"
                    >
                    {t("attendance.download_image")}
                    </button>
                </div>
                </div>
            )}

        </div>
    )
}

export default AttendanceView